import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { OrganizationDetails } from '../../../models/organization-details.model';
import { IDropdown } from '../../../models/dropdown.model';

export const OrganizationAdminActions = createActionGroup({
  source: 'Organization Admin',
  events: {
    // Load Organizations
    'Load Organizations': emptyProps(),
    'Load Organizations Success': props<{ organizations: OrganizationDetails[] }>(),
    'Load Organizations Failure': props<{ error: string }>(),

    // Load Organization Types
    'Load Organization Types': emptyProps(),
    'Load Organization Types Success': props<{ organizationTypes: IDropdown[] }>(),
    'Load Organization Types Failure': props<{ error: string }>(),

    // Load States
    'Load States': emptyProps(),
    'Load States Success': props<{ states: IDropdown[] }>(),
    'Load States Failure': props<{ error: string }>(),

    // Add Organization
    'Add Organization': props<{ organization: OrganizationDetails }>(),
    'Add Organization Success': props<{ organization: OrganizationDetails }>(),
    'Add Organization Failure': props<{ error: string }>(),

    // Update Organization
    'Update Organization': props<{ organization: OrganizationDetails }>(),
    'Update Organization Success': props<{ organization: OrganizationDetails }>(),
    'Update Organization Failure': props<{ error: string }>(),

    // Delete Organization
    'Delete Organization': props<{ organizationId: string }>(),
    'Delete Organization Success': props<{ organizationId: string }>(),
    'Delete Organization Failure': props<{ error: string }>(),

    // Set Test Organization Status
    'Set Test Organization Status': props<{ organizationId: string; isTestOrganization: number }>(),
    'Set Test Organization Status Success': props<{ organizationId: string; isTestOrganization: number }>(),
    'Set Test Organization Status Failure': props<{ error: string }>(),

    // Clear Errors
    'Clear Errors': emptyProps(),
  }
});
